import UseContext from "hooks/useContext";
import {fillTemplate, formatLicenceLabel, getLicenceKind} from "helper/licences";

// Texts of the licences namespace, with the "{type}" word (CACES / permis) of an entry.
const useLicenceTexts = () => {
    const {language} = UseContext();

    const translate = (key, values) => fillTemplate(language.getValue(`licences.${key}`), values);
    const getLabel = (entry) => formatLicenceLabel(entry, language.getValue("licences.label_with_category") || undefined);
    const getTypeWord = (entry) => language.getValue(`licences.types.${getLicenceKind(entry)}`);

    return {translate, getLabel, getTypeWord};
};

export default useLicenceTexts;
